import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-start justify-space-between w-100 py-3" }
const _hoisted_2 = {
  class: "flex-grow-1",
  style: {"min-width":"0"}
}
const _hoisted_3 = {
  class: "mb-0",
  style: {"white-space":"pre-wrap","word-break":"break-all"}
}
const _hoisted_4 = { class: "d-flex flex-shrink-0 pr-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_breakfast_modal = _resolveComponent("breakfast-modal")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createBlock(_component_v_list, { class: "pa-0" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breakfasts, (item, index) => {
        return (_openBlock(), _createBlock(_component_v_list_item, {
          key: item.breakfastId || index,
          class: "border-bottom px-4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(item.content), 1)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  color: "green",
                  density: "comfortable",
                  onClick: ($event: any) => (_ctx.openEditDialog(item))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("mdi-pencil", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  color: "red",
                  density: "comfortable",
                  onClick: ($event: any) => (_ctx.deleteItem(item))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode("mdi-delete", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.isBreakfastDialog,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isBreakfastDialog) = $event))
      }, {
        default: _withCtx(() => [
          (_ctx.isBreakfastDialog)
            ? (_openBlock(), _createBlock(_component_breakfast_modal, {
                key: 0,
                type: "edit",
                breakfastId: _ctx.selectedItem?.breakfastId,
                editContent: _ctx.selectedItem?.content,
                isOpen: _ctx.isBreakfastDialog,
                childId: _ctx.childId,
                selectedDate: _ctx.selectedDate,
                onPosted: _ctx.edited,
                onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isBreakfastDialog = false))
              }, null, 8, ["breakfastId", "editContent", "isOpen", "childId", "selectedDate", "onPosted"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}